



































































import Vue from 'vue';
import {
  CampaignInterface,
  Country,
  DropdownList,
  ERegionType,
  IGeoTarget,
  ObjectValue,
  PaginationData,
  typeTraffic,
  userRoles,
} from '@/types';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import Table from '@/components/table/Table.vue';
import { Column, ColumnItems, FilterTypeField } from '@/components/table/types';
import CamelToUnderscore from '@/utils/CamelToUnderscore';
import moment from 'moment';
import filterParams from '@/components/table/utils/filterParameters';
import InfoHint from '@/components/hints/InfoHint.vue';
import { mapActions, mapGetters } from 'vuex';
import SelectGroupPopup from '@/components/groups/SelectGroupPopup.vue';

export default Vue.extend({
  name: 'Campaigns',
  components: {
    Table,
    InfoHint,
    SelectGroupPopup,
  },

  async created() {
    this.$store.commit('changeTitle', this.$t('pages.campaigns.title'));
    this.getCampaigns(this.getUrlParams);
    await this.$store.dispatch('countries');
    const country = this.columns.find((item: Column): boolean => {
      return item.field === 'country_codes';
    });
    if (country) {
      country.items = this.$store.getters.countriesList;
    }
  },

  async mounted() {
    if (this.userCan(this.roles.ADMIN)) {
      await this.$store.dispatch('users');
      const users = this.columns.find((item: Column): boolean => {
        return item.field === 'user_id';
      });

      if (users) {
        users.items = this.userList;
      }
    }

    const groupId = filterParams.getParamFromUrl('group_id');

    if (!this.group || this.group?.id !== groupId) {
      if (groupId) {
        this.$store.dispatch('campaignGroups/loadGroup', {
          id: groupId,
        });
        Vue.set(this.searchData, 'group_id', groupId);
      }
    }
  },

  computed: {
    ...mapGetters({
      userCan: 'userCan',
      userList: 'userList',
      group: 'campaignGroups/getGroup',
    }),
    getUrlParams(): any {
      return filterParams.getUrlFilter(this.$route.query['filter']) || {};
    },
    getCreateCampaignRoute(): string {
      const route = `/campaign/create?${this.urlParamsGroupId}`;
      return route;
    },
    urlParamsGroupId(): string {
      return this.searchData.group_id
        ? `group_id=${this.searchData.group_id}`
        : '';
    },
    campaigns(): Array<CampaignInterface> {
      return this.$store.state.campaign.campaigns.data.map(
        (item: CampaignInterface) => {
          return {
            id: item.id,
            name: item.full_name,
            type_traffic: item.type_traffic,
            status: item.status,
            group: { ...item.group },
            date: moment(item.created_ts, moment.defaultFormat).format(
              'DD.MM.YY H:mm'
            ),
            geo_values:
              item.geo_values?.map((geo: IGeoTarget) => geo.name) || [],
            geo_type: item.geo_type || ERegionType.INCLUDE,
            screenshot: item.screenshot?.path,
            country_codes: item.countries?.map(
              (country: Country): ObjectValue => {
                return {
                  label: country.name,
                  value: country.code,
                };
              }
            ),
          };
        }
      );
    },
    paginationData(): PaginationData {
      return this.$store.state.campaign.campaigns.paginationData;
    },
  },

  methods: {
    ...mapActions({
      invalidFormNotificationFromBackendAction:
        'invalidFormNotificationFromBackend',
    }),
    renameKey(data: any, key: string) {
      if (!data || !data[key]) {
        return false;
      }
      Object.defineProperty(
        data,
        CamelToUnderscore(key),
        Object.getOwnPropertyDescriptor(data, key) as PropertyDescriptor
      );
      delete data[key];
      return true;
    },
    async getCampaigns(data) {
      let columns: Array<string> = [];
      this.loadData = true;

      this.searchData = data;
      this.columns.map((item: Column, index) => {
        if (data[item.field]) {
          this.columns[index].filterValue = data[item.field];
        } else {
          this.columns[index].filterValue = null;
        }
      });
      if (data.sort) {
        this.sort = data.sort;
      }

      columns = this.columns.map((col) => {
        if (col.field === 'date') {
          return 'created_ts';
        } else if (col.field === 'name') {
          return 'full_name';
        }
        return col.field;
      });
      columns = [...columns, 'geo_type', 'geo_values'];

      await this.$store.dispatch('campaigns', {
        searchData: this.searchData,
        columns,
      });
      filterParams.saveFilter();
      this.loadData = false;
    },
    editCampaign(campaign: CampaignInterface) {
      this.$router.push(
        `/campaign/update/${campaign.id}?${this.urlParamsGroupId}`
      );
    },
    cloneCampaign(campaign: CampaignInterface) {
      (this.$refs.selectGroupPopup as any).open().then(() => {
        this.$router.push(
          `/campaign/clone/${campaign.id}?${this.urlParamsGroupId}&clone=1`
        );
      });
    },
    deleteCampaign(campaign: CampaignInterface) {
      this.$confirm({
        title: this.$t('pages.campaigns.popup.title'),
        content: this.$t('pages.campaigns.popup.message'),
        cancelText: this.$t('body.popup.buttons.no'),
        okText: this.$t('body.popup.buttons.yes'),
      }).then(() => {
        if (!campaign.id) {
          return;
        }
        this.deleteConfirmed(campaign.id);
      });
    },
    async deleteConfirmed(id: number) {
      await this.$store.dispatch('deleteCampaign', { id });
    },
    changeStatusCampaign(index: number) {
      const campaign = this.$store.state.campaign.campaigns.data[index];
      const campaignStatus = { ...campaign.status };

      if (campaignStatus['value'] === 'active') {
        campaignStatus['label'] = this.$t('body.table.body.status.notActive');
        campaignStatus['value'] = 'draft';
      } else {
        campaignStatus['label'] = this.$t('body.table.body.status.active');
        campaignStatus['value'] = 'active';
      }

      const formData = new FormData();

      formData.append('status', campaignStatus.value);

      this.$store
        .dispatch('changeStatusCampaign', {
          id: campaign.id,
          formData,
        })
        .then((response) => {
          if (response.success) {
            campaign.status = campaignStatus;
          } else {
            this.invalidFormNotificationFromBackendAction(campaign.id);
          }
        });
    },
    getCountries(countries: Array<DropdownList>): string {
      return countries.map((c) => c.label).join(', ');
    },
    createCountryPopoverMessage(
      geoType: string,
      geoValues: Array<string>
    ): string {
      if (!geoType || !geoValues?.length) return '';

      const type = geoType.charAt(0).toUpperCase() + geoType.slice(1);
      return `
        ${type}: ${geoValues.join(', ')}
      `;
    },
    selectGroupPopup() {
      if (this.searchData.group_id) {
        this.$router.push(this.getCreateCampaignRoute);
        return;
      }

      (this.$refs.selectGroupPopup as any).open().then(() => {
        this.$router.push(this.getCreateCampaignRoute);
      });
    },
    changeGroup(group) {
      if (group) {
        this.$store.commit('campaignGroups/setGroup', group);
        Vue.set(this.searchData, 'group_id', group.id);
      }
    },
    moveToGroup(selectedIds) {
      (this.$refs.selectGroupPopup as any).open().then(async () => {
        this.sendCampaignsForBindGroup(selectedIds);
      });
    },
    async sendCampaignsForBindGroup(selectedIds) {
      const formData = new FormData();

      if (this.searchData.group_id) {
        formData.append('group_id', this.searchData.group_id.toString());
      }

      if (selectedIds?.length) {
        selectedIds.forEach((id) => {
          formData.append('campaign_ids[]', id.toString());
        });
      }

      await this.$store.dispatch('bindCampaignsToGroup', formData);
      await this.getCampaigns(this.getUrlParams);

      filterParams.changeUrlParams('group_id', this.searchData.group_id);
    },
  },

  data: function () {
    return {
      columns: [
        {
          name: this.$t('pages.campaigns.table.header.id'),
          field: 'id',
          filterValue: null,
          isSticky: true,
          options: {
            minWidth: '100px',
            left: '0',
          },
        },
        {
          name: this.$t('pages.campaigns.table.header.name'),
          field: 'name',
          filterValue: null,
          isSticky: true,
          options: {
            left: '100px',
          },
        },
        {
          name: this.$t('pages.campaigns.table.header.group'),
          field: 'group',
          filterValue: null,
          useInFilter: false,
        },
        {
          name: this.$t('pages.campaigns.table.header.geo'),
          field: 'country_codes',
          filterValue: null,
          items: [],
          filterTypeField: FilterTypeField.FILTER_TYPE_DROPDOWN,
        },
        {
          name: this.$t('pages.campaigns.table.header.trafficType'),
          field: 'type_traffic',
          items: [
            {
              label: this.$t('body.table.body.trafficType.banner'),
              htmlLabel: `<span class="td-status">${this.$t(
                'body.table.body.trafficType.banner'
              )}</span>`,
              value: typeTraffic.BANNER,
            },
            {
              label: this.$t('body.table.body.trafficType.push'),
              htmlLabel: `<span class="td-status">${this.$t(
                'body.table.body.trafficType.push'
              )}</span>`,
              value: typeTraffic.PUSH,
            },
            {
              label: this.$t('body.table.body.trafficType.native'),
              htmlLabel: `<span class="td-status">${this.$t(
                'body.table.body.trafficType.native'
              )}</span>`,
              value: typeTraffic.NATIVE,
            },
          ] as Array<ColumnItems>,
          filterValue: null,
          filterTypeField: FilterTypeField.FILTER_TYPE_DROPDOWN,
        },
        {
          name: this.$t('pages.campaigns.table.header.status'),
          field: 'status',
          items: [
            {
              label: this.$t('body.table.body.status.active'),
              htmlLabel: `<span class="td-status td-status-active">${this.$t(
                'body.table.body.status.active'
              )}</span>`,
              value: 'active',
            },
            {
              label: this.$t('body.table.body.status.notActive'),
              htmlLabel: `<span class="td-status td-status-no-active">${this.$t(
                'body.table.body.status.notActive'
              )}</span>`,
              value: 'draft',
            },
          ] as Array<ColumnItems>,
          filterValue: null,
          filterTypeField: FilterTypeField.FILTER_TYPE_DROPDOWN,
        },
        {
          name: this.$t('pages.campaigns.table.header.creationDate'),
          field: 'date',
          filterTypeField: FilterTypeField.FILTER_TYPE_DATERANGE,
          filterValue: null,
        },
        {
          name: this.$t('pages.statisticsCampaign.topBar.selectUser'),
          field: 'user_id',
          items: [],
          visible: false,
          filterTypeField: FilterTypeField.FILTER_TYPE_DROPDOWN_FIELD,
          filterValue: null,
          role: userRoles.ADMIN,
        },
      ] as Array<Column>,
      sort: null as string | null,
      currentExchange: null,
      rowData: null as Array<any> | null,
      loadData: true,
      gridOptions: {
        pagination: true,
      },
      searchData: {} as { [name: string]: string | number },
      roles: {
        ADMIN: userRoles.ADMIN,
        MANAGER: userRoles.MANAGER,
        SSP: userRoles.SSP,
        PUBLISHER: userRoles.PUBLISHER,
      },
    };
  },
});
